export interface WorkerSuggestion {
  id: number;
  name: string;
  email: string;
  profileImageUrl: string;
  alreadyEndorsed: boolean;
}

export interface WorkerSuggestionsResponse {
  suggestions: WorkerSuggestion[];
}

export enum EventsNumber {
  N_1_2 = 'N_1_2',
  N_3_6 = 'N_3_6',
  N_7_9 = 'N_7_9',
  N_10_PLUS = 'N_10_PLUS',
}

export interface EndorsementFormData {
  workerId?: number;
  email: string;
  fullName: string;
  companyName: string;
  reviewDescription?: string;
  photoIsRepresentative?: boolean;
  performance?: number;
  isEndorsedManager: boolean;
  sharedEventsNumber: EventsNumber;
  sharedEventsType: number[];
  endorsedTraits: number[];
}

export interface EndorsementPayload {
  workerId: number | null;
  email: string;
  fullName: string;
  companyName: string;
  reviewDescription: string | null;
  photoIsRepresentative: boolean | null;
  performance: number | null;
  isEndorsedManager: boolean;
  sharedEventsNumber: EventsNumber;
  sharedEventsType: number[];
  endorsedTraits: number[];
}
